import UploaderComponent from "./uploader.js";
import UploaderImage from "./uploader-image.js";
import UploaderUpload from "./uploader-upload.js";
const Uploader = UploaderComponent;
Uploader.Upload = UploaderUpload;
Uploader.Image = UploaderImage;
export default Uploader;
